import { useEffect } from 'react';

import styles from './AgedDebtorReport.module.css';
import { useGetDocuments } from '../../../../api/lendingApi/lendingApiQueries';
import { useContextStateKey } from '../../../../hooks/useContextStateKey';
import { useFileUploadReducer } from '../../../../hooks/useFileUploadReducer';
import DocumentUploadSection from '../components/DocumentUploadSection/DocumentUploadSection';

const DOCUMENT_TYPE = 'aged debtor report';
const listOfInstructions = [
  <>
    This should be a list of invoices you have issued but are yet to be paid,
    and ideally grouped by the number of days outstanding e.g. (30, 60, 90+
    days).{' '}
    <a
      href="https://gocardless.com/guides/posts/aged-debtors-report/"
      target="_blank"
      rel="noreferrer"
    >
      Learn more
    </a>
    .
  </>,
];

type TProps = {
  isActive: boolean;
  isError?: boolean;
  onRequestUpload: () => void;
};

const AgedDebtorReport = ({ isActive, isError, onRequestUpload }: TProps) => {
  const stateKey = useContextStateKey();
  const { documents } = useGetDocuments(stateKey);

  const {
    uploadedFiles,
    setAllFiles,
    setFileLoading,
    setFileSuccess,
    setFileError,
    setFileReject,
    removeFile,
  } = useFileUploadReducer();

  useEffect(() => {
    if (documents) {
      const agedDebtorDocuments = documents.data.filter(
        (document) => document.attributes.document_type === DOCUMENT_TYPE,
      );
      setAllFiles(agedDebtorDocuments);
    }
  }, [documents]);

  return (
    <div className={styles.container}>
      <DocumentUploadSection
        documentType={DOCUMENT_TYPE}
        listOfInstructions={listOfInstructions}
        uploadedFiles={uploadedFiles}
        isActive={isActive}
        isError={isError}
        setFileLoading={setFileLoading}
        setFileSuccess={setFileSuccess}
        setFileError={setFileError}
        setFileReject={setFileReject}
        removeFile={removeFile}
        onRequestUpload={onRequestUpload}
      />
    </div>
  );
};

export default AgedDebtorReport;
